module.exports = __webpack_public_path__ + "static/media/hongtoushan_web.75b50019.webp";